import _ from 'lodash';
import { mapActions } from 'vuex';
import { initDycolor, CreativePreview, CreativePreviewScaled, adapi, permissions } from '~';
import { CREATIVE_STATUSES } from '@/util/constants';

initDycolor('post', require(`${process.env.DYCOLOR_REQUIRE}./Creative.scss`)); // eslint-disable-line

export default {
  props: {
    creative: Object,
    facebookPage: Object,
    showActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activatingCreative: false,
    };
  },
  components: {
    'creative-preview-scaled': CreativePreviewScaled,
    'creative-preview': CreativePreview,
  },
  computed: {
    landingPage() {
      return _.get(this.creative, 'campaign.landingpages.[0]', null);
    },
    createdAt() {
      return this.$t('fn.date', { timestamp: this.creative.created_at });
    },
    active() {
      return this.showActive && this.creative.active;
    },
    isApproved() {
      return this.creative.status === CREATIVE_STATUSES.APPROVED;
    },
    permissions() {
      return permissions.getPermissions(this.creative);
    },
  },
  methods: {
    ...mapActions('campaign', ['reloadCampaign']),
    edit() {
      this.$router.push({
        name: 'creative',
        params: { id: this.creative.id },
      });
    },
    activateCreative() {
      this.activatingCreative = true;
      return adapi.post(`creatives/${this.creative.id}/activate`)
        .then(() => {
          this.$toast.success({ message: this.$t('pos.creative.creative-activated') });
          this.activatingCreative = false;
        })
        .then(() => this.reloadCampaign())
        .catch(e => {
          this.$toast.error({ message: e.toString() });
          this.activatingCreative = false;
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/campaign-creatives/creative/Creative.js